import axios from 'axios';
import {
	ENDPOINT_URL,
	HOME_DASHBOARD_STATS_API,
} from '../../../constants/commonConstants';
import {decodeAgentResponse} from '../../core/resolutionUtils';

/**
 * Read a whole number from an API value.
 * @param {*} value API value
 * @return {number} count
 */
function count(value) {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * Report how many Switches are online and offline.
 *
 * The same endpoint the Access Point counts come from, one field across.
 * Canvas already totals these for the Home Dashboard header - the 999 and 7
 * beside "Switches (1006)" - so they are read from there rather than tallied
 * from a lookup, which would undercount any tenant with more switches than
 * one page of results holds.
 *
 * Always the global figures, never scoped to the page: the number people
 * check an answer against is the one on the Home Dashboard.
 *
 * @return {Promise<{values: {online: number, offline: number, total: number}}>} counts
 */
export async function readSwitchStatusCounts() {
	const {data} = await axios.get(`${ENDPOINT_URL}${HOME_DASHBOARD_STATS_API}`);
	const document = decodeAgentResponse(data) || {};
	const stats = document?.data ?? document;
	const rows = Array.isArray(stats?.switch_online_offline)
		? stats.switch_online_offline
		: [];
	const forState = (connected) => count(
		rows.find((row) => Number(row?.is_connected) === connected)?.count,
	);
	const online = forState(1);
	const offline = forState(0);
	return {values: {online, offline, total: online + offline}};
}
